import { createContext, useContext } from 'react';

export const CommonUIActionsContext = /*#__PURE__*/ createContext<{
  userDataAPI: any;
  onSiteRegistrationAPI: any;
  preRegistrationAPI: any;
  formAPI: any;
}>({
  userDataAPI: null,
  onSiteRegistrationAPI: null,
  preRegistrationAPI: null,
  formAPI: null,
});

export const useCommonUIActionsContext = () => {
  const commonUIContext = useContext(CommonUIActionsContext);

  const context = commonUIContext;

  if (!context) {
    console.error('ActionContext must be used within a provider.');
    return undefined;
  }

  return context;
};
